import React, {useEffect, useMemo, useRef, useState} from "react";
import {
    Box, Button, Collapse,
    FormControl, IconButton,
    InputLabel,
    MenuItem,
    Paper, Popover,
    Select,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";


import {usePDF} from 'react-to-pdf';
import {useWebSocket} from "../net/WebSocketContext";
import BlurredComponent_all from "../common/BlurredComponent_all";
import ReactMarkdown from "react-markdown";
import {getBalls, getBallsJJ, getScore, roundTo3, fixNaN, getSkatingPlaces} from "../common/CalculateScores";
import AlertDialog from "../common/Dialog";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {styled} from "@mui/material/styles";
import VideoPlayer from "../common/VideoPlayer";
import AlertDialogNote from "../common/DialogNote";
import {Link, useNavigate} from "react-router-dom";
const Results = () => {
    const navigate = useNavigate();
    const {toPDF, targetRef} = usePDF({
        page: {
            // margin is in MM, default is Margin.NONE = 0
            margin: 2,
            // default is 'A4'
            format: 'A4',
            // default is 'portrait'
            orientation: 'landscape',
        },
        method: "open",
        filename: 'page.pdf'
    });
    const {ws, isConnected, results, refresh, loading, progress, all_users_list} = useWebSocket();
    const [dance_set, setDanceSet] = useState({});
    const [dance_set_slow, setDanceSetSlow] = useState({});
    const [dance_set_arr, setDanceSetArr] = useState([]);
    const [dance_set_obj, setDanceSetObj] = useState({
        leaders: [],
        followers: []
    });
    const [generated, setGenerated] = useState(false);
    const [dance_complete, setDance_complete] = useState(false);
    const [final_complete, setFinal_complete] = useState(false);
    const [events, setEvents] = useState([]);
    const [users, setUsers] = useState([]);
    const [wait, setWait] = useState(false);
    const [isPrint, setIsPrint] = useState(false);
    const [isEndJudging, setIsEndJudging] = useState(false);
    const [selectListRound, setSelectListRound] = useState(0);
    const [pair_count, setPairCount] = useState(10);
    const [selectedJudges, setSelectedJudges] = useState({
        leaders: [],
        followers: []
    });
    const [jjBalls, setJjBalls] = useState({
        yes: 0,
        maybe: 0
    })
    const [filters, setFilters] = useState(() => {
        return (
            JSON.parse(localStorage.getItem("results_filters")) ||
            {
                event: null,
                dance: "",
                category: "",
                class: "",
                round: "",
                role:"Followers"
            })
    });
    const filters_ref = useRef({});

    const [start, setStart] = useState(true);
    const [isDone, setIsDone] = useState(true);
    const [isSort, setIsSort] = useState(true);
    const [isEnd, setIsEnd] = useState(true);
    const [personalFinal, setPersonalFinal] = useState(false);
    const [personalRound, setPersonalRound] = useState(true);
    const [users_id, setUsers_id] = useState([]);


    useEffect(() => {
        console.log("all_users_list",all_users_list)
        if (isConnected && all_users_list?.users){
            setUsers_id(prev => [...prev, ...all_users_list?.users ])
        }
    }, [all_users_list]);

    useEffect(() => {
        filters_ref.current = JSON.parse(localStorage.getItem("results_filters")) ||
            {
                event: null,
                dance: "",
                category: "",
                class: "",
                round: ""
            };

    }, []);
    useEffect(() => {
        localStorage.setItem("results_filters", JSON.stringify(filters));
    }, [filters]);
    useEffect(() => {
        if (
            filters.event === null ||
            filters.dance === null ||
            filters.category === null ||
            filters.class === null

        ) {
            getUserList()
            return
        }
        //console.log(filters.event)
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "results",
                event: filters.event?.event?.value ?? null,
                dance: filters.dance,
                category: filters.category,
                class: filters.class,
                round: filters?.round ?? false
            }
            setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else console.log("Нет готовности отправлять по ws ")
    }, []);

    useEffect(() => {
            getSetRefresh()
    }, [refresh]);
    useEffect(() => {

            console.log("ON_MESSAGE Sets", results)

            if (results?.type === "users_list") {
                if (results?.users_list) {
                    setUsers(results.users_list);
                }
                if (results?.events) {
                    setEvents(results.events);
                }
            }
            if (results?.type === "results") {
                if (results?.users_list) {
                    setUsers(results.users_list);
                }
                if (results?.events) {
                    setEvents(results.events);
                }

                if (results?.set) {
                    setDanceSet(results);
                    if (results?.category === "Strictly") {
                        setDanceSetArr(results.set)
                    }
                    if (results?.category === "J&J") {
                        setDanceSetObj(
                            {
                                leaders: [...results?.set.filter(f => f?.leader?.id)],
                                followers: [...results?.set.filter(f => f?.follower?.id)]
                            })
                    }
                    setGenerated(results?.generated);
                }
                if (results?.slow) {
                    setDanceSetSlow(results?.slow);
                }
                if (results?.init_set) {
                    setJjBalls(results?.init_set?.jjBalls)
                    setPairCount(results?.init_set?.pair_count)
                }
                if (results?.judging_list) {
                    setSelectedJudges(results?.judging_list)
                }
            }
        setWait(false)
    }, [results]);
    const ScoreDescription = () => {
        return(
            <ReactMarkdown>
                {
                    `bm  - Базовая техника основного хода партнера

bw  - Базовая техника основного хода партнерши

lfw - Ведение-следование, базовые фигуры, гармония в паре

dfe - Танцевальные фигуры и чистота их исполнения

mi  - Музыкальность`}
            </ReactMarkdown>
        )
    }
    const getUserList = () => {
        if (!ws) {
            console.log("Нет готовности отправлять по ws")
            return;
        }
        const sendOnOpen = () => {
            setWait(true)
            ws.zsend(JSON.stringify({action: "users_list"}));
            console.log("SEND:", {action: "users_list"});
        };
        if (ws.readyState === WebSocket.OPEN) {
            sendOnOpen();
        } else {
            ws.addEventListener("open", sendOnOpen);
        }
        return () => {
            ws.removeEventListener("open", sendOnOpen);
        };
    }
    //Алгоритм Фишера–Йетса для случайного перемешивания.
    const getSetR = () => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "results",
                event: filters_ref.current.event?.event?.value ?? null,
                dance: filters_ref.current.dance,
                category: filters_ref.current.category,
                class: filters_ref.current.class,
                round: filters_ref?.current.round ?? false,
            }
            if(filters_ref?.current?.category === "J&J"){
                setPairCount(10)
            }
            if(filters_ref?.current?.category === "Strictly"){
                setPairCount(1)
            }
            setIsEndJudging(false)
            setWait(true)
            setSelectedJudges({
                leaders: [],
                followers: []
            })
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    };
    const getSetRefresh = () => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "results",
                event: filters_ref.current.event?.event?.value ?? null,
                dance: filters_ref.current.dance,
                category: filters_ref.current.category,
                class: filters_ref.current.class,
                round: filters_ref?.current.round ?? false,
            }
            if(filters_ref?.current?.category === "J&J"){
                setPairCount(10)
            }
            if(filters_ref?.current?.category === "Strictly"){
                setPairCount(1)
            }
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    };
    const rounds = () => {
        return events.filter(event => (event?.event?.value ?? null) === filters?.["event"]?.event?.value)?.[0]?.['roundList']?.[filters?.["dance"]]?.[filters?.["category"]]?.[filters?.["class"]] ?? []
    }
    const toDance = (place, event, dance, category, dance_class, round, number, leader, follower, roles) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "judging_start",
                place, event, dance, category, class: dance_class, round, number, leader, follower, selectedJudges, roles
            }
            setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }
    const cancelDance = (place, event, dance, category, dance_class, round, number, leader, follower, roles) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "judging_cancel",
                place, event, dance, category, class: dance_class, round, number, leader, follower, selectedJudges, roles
            }
            setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }
    const toFinal = (place, event, dance, category, dance_class, round, number, leader, follower) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            let body = {
                action: "judging_to_final",
                place, event, dance, category, class: dance_class, round, number, leader, follower
            }
            setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }
    const getNextRound = (current_round) =>{
        const roundList = filters?.event?.roundList?.[filters?.dance]?.[filters?.category]?.[filters?.class] ?? []
        return roundList[(roundList)?.indexOf(current_round)+1] ?? false
    }
    const toNextRound = (place, event, dance, category, dance_class, round, number, leader, follower) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            const nextRound = getNextRound(round)
            let body = {
                action: "judging_to_next_round",
                place, event, dance, category, class: dance_class,
                round:nextRound,
                number, leader, follower
            }
            setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }

    const toNextRoundCancel = (place, event, dance, category, dance_class, round, number, leader, follower) => {
        if (ws && ws.readyState === WebSocket.OPEN) {
            const nextRound = getNextRound(round)
            let body = {
                action: "judging_to_next_round_cancel",
                place, event, dance, category, class: dance_class,
                round:nextRound,
                number, leader, follower, personalFinal
            }
            //setWait(true)
            ws.zsend(JSON.stringify(body));
            console.log("SEND:", body);
        } else {
            console.log("Нет готовности отправлять по ws ")
        }
    }
    const getFinal = (leader_id, dance_set_) => {
        return users.find(u => u._id === leader_id)
            ?.['events']
            ?.[dance_set_?.event]
            ?.['danceSelections']
            ?.[dance_set_?.dance]
            ?.[dance_set_?.category]
            ?.['cards']
            ?.['slow_final']
            ?.[dance_set_?.class]?.final
    }
    const getRoundAccess = (user_id, dance_set_, round) => {
        return users.find(u => u._id === user_id)
            ?.['events']
            ?.[dance_set_?.event]
            ?.['danceSelections']
            ?.[dance_set_?.dance]
            ?.[dance_set_?.category]
            ?.['cards']
            ?.[round]
            ?.[dance_set_?.class]?.[round]
    }
    // Сортировка J&J
    const sortedDataObj = useMemo(() => {
        if (isDone || isSort) {
            return {
                leaders: [...dance_set_obj?.leaders].sort((a, b) => {
                    let valueA, valueB
                    valueA = getBallsJJ(a?.leader?.id, dance_set,users)
                    valueB = getBallsJJ(b?.leader?.id, dance_set,users)
                    return Number(valueB) - Number(valueA);
                }),
                followers: [...dance_set_obj?.followers].sort((a, b) => {
                    let valueA, valueB
                    valueA = getBallsJJ(a?.follower?.id, dance_set,users)
                    valueB = getBallsJJ(b?.follower?.id, dance_set,users)
                    return Number(valueB) - Number(valueA);
                })
            }
        } else {
            return dance_set_obj;
        }
    }, [dance_set_obj, isDone, isSort])

    const sortedDataSkatingObj = useMemo(() => {
        if (isDone || isSort) {
            return {
                leaders: [...dance_set_obj?.leaders].sort((a, b) => {
                    let valueA, valueB
                    valueA = getSkatingPlaces(a?.leader?.id, dance_set,users) ?? "";
                    valueB = getSkatingPlaces(b?.leader?.id, dance_set,users) ?? "";
                    return Number(valueA) - Number(valueB);
                }),
                followers: [...dance_set_obj?.followers].sort((a, b) => {
                    let valueA, valueB
                    valueA = getSkatingPlaces(a?.follower?.id, dance_set,users, "follower") ?? "";
                    valueB = getSkatingPlaces(b?.follower?.id, dance_set,users, "follower") ?? "";
                    return Number(valueA) - Number(valueB);
                })
            }
        } else {
            return dance_set_obj;
        }
    }, [dance_set_obj, isDone, isSort])

    // Сортировка Strictly
    const sortedData = useMemo(() => {
        if (isDone || isSort) {
            const result = [...dance_set_arr].sort((a, b) => {
                let valueA, valueB
                if (dance_set?.round === "fast" || dance_set?.round === "fast_final") {
                    valueA = roundTo3((getBalls(a?.leader?.id, dance_set,users) + (getBalls(a?.leader?.id, dance_set,users) * 0.1)) + getBalls(a?.leader?.id, dance_set_slow, users))
                    valueB = roundTo3((getBalls(b?.leader?.id, dance_set,users) + (getBalls(b?.leader?.id, dance_set,users) * 0.1)) + getBalls(b?.leader?.id, dance_set_slow, users))
                } else {
                    valueA = getBalls(a?.leader?.id, dance_set,users) ?? "";
                    valueB = getBalls(b?.leader?.id, dance_set,users) ?? "";
                }
                return Number(valueB) - Number(valueA);
            });
            //console.log("result",result)
            return result
        } else {
            return dance_set_arr
        }
    }, [dance_set_arr, isDone, isSort]);
    const renderStrictlyTable = () => {
        return (
            <div ref={targetRef} style={{width: isPrint ? "1200px" : "auto" }}>
                <Typography align="center" variant="subtitle1">
                    {
                        filters?.event?.event?.name
                        + ' ' + (filters?.dance ?? "")
                        + ' ' + (filters?.category ?? "")
                        + ' ' + (filters?.class ?? "")
                        + ' ' + (filters?.round ?? "")
                        + ' ' + (filters?.final ?? "")
                        + ' ' + (isDone ? 'Результаты ' :'Заход')
                    }
                </Typography>
                <div>
                    <TableContainer component={Paper} sx={{mt: 3}}>
                        <Table style={{    minWidth: "800px"}}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{"Место"}</TableCell>
                                    <TableCell>Номер пары</TableCell>
                                    <TableCell>Leader</TableCell>
                                    <TableCell>Follower</TableCell>
                                    <TableCell
                                        key="balls"
                                        sx={{
                                            lineHeight: "0.9rem"
                                        }}>
                                        <div style={{
                                            marginBottom: '-14px'
                                        }}
                                        >Баллы</div>
                                        <div
                                            style={{
                                                fontSize: "10px",
                                                paddingTop: '15px',
                                                marginBottom: '-17px'
                                            }}>bm|bw|lfw|dfe|mi</div>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            {sortedData?.every(item => Object?.values(item?.jading_status ?? [{e:0}] )?.every(status => status === 2))  && filters?.round !== '' ?
                                <TableBody>
                                    {( sortedData ?? []).map((set, index) => {
                                        return (
                                            <TableRow key={`${index}`}
                                                      hover={false}>
                                                <TableCell>{Math?.trunc((index)/pair_count) + 1}</TableCell>
                                                <TableCell>{set?.number ?? null}</TableCell>
                                                <TableCell>{set?.leader?.name ?? "_"}</TableCell>
                                                <TableCell>{set?.follower?.name ?? "_"}</TableCell>
                                                {set?.jading_status ?
                                                    <TableCell sx={{pt: "4px", pb:"4px"}}>
                                                        <AlertDialogNote
                                                            ok={"Понятно"}
                                                            okFn={()=>{}}
                                                            cancel="Непонятно"
                                                            cancelFn={
                                                                ()=>{navigate("/how_bw")}
                                                            }

                                                        message={
                                                            <>

                                                                <ReactMarkdown>
                                                                    {
                                                                        `
##### ${filters?.event?.event?.name
                                                                        + ' ' + (filters?.dance ?? "")
                                                                        + ' ' + (filters?.category ?? "")
                                                                        + ' ' + (filters?.class ?? "")
                                                                        + ' ' + (filters?.round ?? "")
                                                                        + ' ' + (filters?.final ?? "")}
### ${set?.leader?.name} и ${set?.follower?.name}
- bm  - Базовая техника основного хода партнера
- bw  - Базовая техника основного хода партнерши
- lfw - Ведение-следование, базовые фигуры, гармония в паре
- dfe - Танцевальные фигуры и чистота их исполнения
- mi  - Музыкальность (музыкальная интерпретация)
`}
                                                                </ReactMarkdown>
                                                                <div
                                                                    style={{
                                                                        fontSize: "20px",
                                                                    }}>bm|bw|lfw|dfe|mi

                                                                </div>
                                                                {Object.entries(set?.jading_status).map(([key, value]) => {
                                                                    return <div style={{fontSize: "20px"}}
                                                                                key={`${key}`}>
                                                                        {getScore(set?.leader?.id, dance_set, users)?.[key]?.basic_leader.toFixed(1)
                                                                            + '|' + getScore(set?.leader?.id, dance_set, users)?.[key]?.basic_follow.toFixed(1)
                                                                            + '|' + (
                                                                                getScore(set?.leader?.id, dance_set, users)?.[key]?.lfbdh +
                                                                                getScore(set?.leader?.id, dance_set, users)?.[key]?.dance_perf +
                                                                                getScore(set?.leader?.id, dance_set, users)?.[key]?.bonus1 * 1).toFixed(1)
                                                                            + '|' + (
                                                                                getScore(set?.leader?.id, dance_set, users)?.[key]?.execution +
                                                                                getScore(set?.leader?.id, dance_set, users)?.[key]?.diff_var +
                                                                                getScore(set?.leader?.id, dance_set, users)?.[key]?.bonus2 * 1).toFixed(1)
                                                                            + '|' + (
                                                                                getScore(set?.leader?.id, dance_set, users)?.[key]?.interpret +
                                                                                getScore(set?.leader?.id, dance_set, users)?.[key]?.spontan +
                                                                                getScore(set?.leader?.id, dance_set, users)?.[key]?.bonus3 * 1).toFixed(1)
                                                                        }

                                                                    </div>
                                                                })}
                                                                {isDone ? (
                                                                        (dance_set?.round === 'fast' || dance_set?.round === 'fast_final') ?
                                                                            <div style={{fontSize: "25px"}}>
                                                                                {dance_set?.round}:
                                                                                {
                                                                                    " " + (roundTo3(getBalls(set?.leader?.id, dance_set, users) + (getBalls(set?.leader?.id, dance_set, users) * 0.1)))
                                                                                    + (dance_set_slow?.round !== undefined ? " + " + dance_set_slow?.round + ": " + getBalls(set?.leader?.id, dance_set_slow, users)
                                                                                        + " → " +
                                                                                        (roundTo3((roundTo3((getBalls(set?.leader?.id, dance_set, users) + (getBalls(set?.leader?.id, dance_set, users) * 0.1)) + getBalls(set?.leader?.id, dance_set_slow, users)) * 65) / 136.5))
                                                                                        : "" )
                                                                                    || '_'}
                                                                            </div> :
                                                                            <div style={{fontSize: "25px"}}>
                                                                                {dance_set?.round !== "" ? dance_set?.round : "Сумма"}: {getBalls(set?.leader?.id, dance_set, users) || '_'}</div>
                                                                    )
                                                                    : ((dance_set?.round === 'fast' || dance_set?.round === 'fast_final') ?
                                                                            (roundTo3((roundTo3((getBalls(set?.leader?.id, dance_set, users) + (getBalls(set?.leader?.id, dance_set, users) * 0.1)) + getBalls(set?.leader?.id, dance_set_slow, users)) * 65) / 136.5)) || '_'
                                                                            : getBalls(set?.leader?.id, dance_set, users) || '_'

                                                                    )
                                                                }

                                                            </>
                                                        }
                                                        >
                                                            {Object.entries(set?.jading_status).map(([key, value]) => {
                                                                return <div style={{fontSize: "10px"}} key={`${key}`}>

                                                                    {getScore(set?.leader?.id, dance_set, users)?.[key]?.basic_leader.toFixed(1)
                                                                + '|' + getScore(set?.leader?.id,dance_set, users)?.[key]?.basic_follow.toFixed(1)
                                                                + '|' +  (
                                                                    getScore(set?.leader?.id,dance_set, users)?.[key]?.lfbdh  +
                                                                    getScore(set?.leader?.id,dance_set, users)?.[key]?.dance_perf  +
                                                                    getScore(set?.leader?.id,dance_set, users)?.[key]?.bonus1*1 ).toFixed(1)
                                                                + '|' +  (
                                                                    getScore(set?.leader?.id,dance_set, users)?.[key]?.execution  +
                                                                    getScore(set?.leader?.id,dance_set, users)?.[key]?.diff_var  +
                                                                    getScore(set?.leader?.id,dance_set, users)?.[key]?.bonus2*1 ).toFixed(1)
                                                                + '|' +  (
                                                                    getScore(set?.leader?.id,dance_set, users)?.[key]?.interpret  +
                                                                    getScore(set?.leader?.id,dance_set, users)?.[key]?.spontan  +
                                                                    getScore(set?.leader?.id,dance_set, users)?.[key]?.bonus3*1 ).toFixed(1)
                                                            }

                                                        </div>
                                                    })}
                                                        {isDone ? (
                                                                (dance_set?.round === 'fast' || dance_set?.round === 'fast_final') ?
                                                                    <div style={{fontSize: "10px"}}>
                                                                        {dance_set?.round}:
                                                                        {
                                                                            " "+(roundTo3(getBalls(set?.leader?.id, dance_set, users) + (getBalls(set?.leader?.id, dance_set, users)* 0.1)))
                                                                            + (dance_set_slow?.round !== undefined ? " + " + dance_set_slow?.round + ": " + getBalls(set?.leader?.id, dance_set_slow, users)
                                                                                + " → " +
                                                                                (roundTo3((roundTo3((getBalls(set?.leader?.id, dance_set, users) + (getBalls(set?.leader?.id, dance_set, users) * 0.1)) + getBalls(set?.leader?.id, dance_set_slow, users)) * 65) / 136.5))
                                                                                : "" )
                                                                            || '_'}
                                                                    </div> :
                                                                    <div style={{fontSize: "10px"}}>
                                                                        {dance_set?.round !==  "" ? dance_set?.round :"Сумма"}: {getBalls(set?.leader?.id, dance_set, users) || '_'}</div>
                                                            )
                                                            :      ((dance_set?.round === 'fast' || dance_set?.round === 'fast_final')  ?
                                                                    (roundTo3((roundTo3((getBalls(set?.leader?.id, dance_set, users) + (getBalls(set?.leader?.id, dance_set, users)* 0.1))  + getBalls(set?.leader?.id, dance_set_slow, users))*65)/136.5)) || '_'
                                                                    : getBalls(set?.leader?.id, dance_set, users) || '_'

                                                            )
                                                        }
                                                        </AlertDialogNote>
                                                    </TableCell> :''
                                                }
                                            </TableRow> )}
                                    )}
                                </TableBody> : ''}
                        </Table>
                    </TableContainer>
                </div>
            </div>
        )
    }

    const sortedDataSkating = useMemo(() => {
        if (isDone || isSort) {
            const result =
                personalRound  || filters?.round === "1"? // if skating?
                    [...dance_set_arr].sort((a, b) => {
                        let valueA, valueB
                        valueA = getSkatingPlaces(a?.leader?.id, dance_set,users) ?? "";
                        valueB = getSkatingPlaces(b?.leader?.id, dance_set,users) ?? "";
                        return Number(valueA) - Number(valueB);
                    } )
                    :   //else jj
                    [...dance_set_arr].sort((a, b) => {
                        let valueA, valueB
                        valueA = getBallsJJ(a?.leader?.id, dance_set,users)
                        valueB = getBallsJJ(b?.leader?.id, dance_set,users)
                        return Number(valueB) - Number(valueA);
                    } )
            console.log("result",result)
            return result
        } else {
            return dance_set_arr
        }
    }, [dance_set_arr, isDone, isSort]);
    const renderSkatingTableOnly = (role, roles) =>{
        return (
            <TableContainer component={Paper} sx={{maxHeight: (window.innerHeight - 165) + 'px'}}
            >
                <Table stickyHeader style={{minWidth: "350px"}}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{isDone ? "Место" : "Номер захода"}</TableCell>
                            <TableCell>Номер пары</TableCell>
                            { role ? ( role === "leader" ? <TableCell>Leader</TableCell> : "" ) : <TableCell>Leader</TableCell>}
                            { role ? ( role === "follower" ? <TableCell>Follower</TableCell> : "" ) : <TableCell>Follower</TableCell>}
                            {(!generated && start) ?
                                <TableCell>{isDone ? "" : "Судейство"}</TableCell> : ''}
                            {isDone && (filters?.round === 'fast' || filters?.round === 'hope') ?
                                <TableCell></TableCell> : ''}
                            {isDone && (filters?.round !== '1') ?
                                <TableCell padding="normal"></TableCell> : ''}

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(
                                //(personalFinal && filters?.round === "1") ?
                                (sortedDataSkatingObj?.[roles ? roles : "leaders"])

                               // :  (sortedDataSkating ?? [])
                        )
                            .map((set, index) => {
                                    return (
                                        <TableRow key={`${index}`} style={{
                                            backgroundColor: (Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2) && !isDone) ? "#008f0029" :
                                                ((set?.jading_status && !isDone) ? "#ffa50029" : null)
                                        }}
                                                  hover={false}>
                                            <TableCell>{isDone ? index + 1 : Math?.trunc((index) / pair_count) + 1}</TableCell>
                                            <TableCell>{set?.number ?? null}</TableCell>
                                            { role ? ( role === "leader" ? <TableCell>{set?.leader?.name ?? "_"}</TableCell> : "" ) : <TableCell>{set?.leader?.name ?? "_"}</TableCell>}
                                            { role ? ( role === "follower" ?  <TableCell>{set?.follower?.name ?? "_"}</TableCell> : "" ) : <TableCell>{set?.follower?.name ?? "_"}</TableCell>}


                                            {!generated && start ?
                                                (set?.jading_status ?
                                                        ( personalRound  || filters?.round === "1" ?
                                                                <TableCell // как секйтинг
                                                                    style={{}}>{Object.entries(set?.jading_status).map(([key, value]) => {
                                                                    return !isDone ?
                                                                        <div
                                                                            key={`${key}`}>
                                                                            <div
                                                                                style={{display: "flex", fontSize: "10px"}}
                                                                            >
                                                                                {
                                                                                    <div style={{display: "flex"}}>
                                                                                        <div style={{
                                                                                            width: '10px',
                                                                                            height: '10px',
                                                                                            backgroundColor: value === 0 ? "red" : (value === 1 ? "yellow" : "green"),
                                                                                            borderRadius: '50%',
                                                                                            marginRight: '2px'
                                                                                        }}></div>
                                                                                        {users_id?.find(u => u?._id === key)?.name}
                                                                                    </div>

                                                                                }: {value === 0 ?
                                                                                "Не готов"
                                                                                : (value === 1 ?
                                                                                    "Судит" : (
                                                                                        value === 2 ?
                                                                                            getScore(set?.[role ? role : "leader"]?.id, dance_set, users)?.[key]?.skating_place?.toFixed(0)
                                                                                            : "Что то не так"))}

                                                                            </div>
                                                                        </div> : ''
                                                                })}
                                                                    {!isDone ? getSkatingPlaces(set?.[role ? role : "leader"]?.id, dance_set, users, role ? role : null) : ''}
                                                                    {(Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2) || isDone) ?
                                                                        "" :
                                                                        <AlertDialog
                                                                            variant={'text'}
                                                                            size={"small"}
                                                                            sx={{mb: -2}}
                                                                            name='Отменить'
                                                                            main_message='Отменить судейство?'
                                                                            message='Это отменит судейство'
                                                                            ok='Отменить'
                                                                            cancel='Подумаю еще'
                                                                            okFn={() => {
                                                                                cancelDance(
                                                                                    set?.number,
                                                                                    filters['event']?.event?.value ?? null,
                                                                                    filters['dance'] ?? null,
                                                                                    filters['category'] ?? null,
                                                                                    filters['class'] ?? null,
                                                                                    filters['round'] ?? null,
                                                                                    set?.number ?? null,
                                                                                    set?.leader ?? null,
                                                                                    set?.follower ?? null,
                                                                                    role ? role : "leaders"
                                                                                )
                                                                            }}
                                                                            // enabled={isDone}
                                                                        />}
                                                                </TableCell> :
                                                                <TableCell
                                                                    padding="normal"
                                                                    style={{}}>{Object.entries(set?.jading_status).map(([key, value], index) => {
                                                                    return (
                                                                        <div style={{
                                                                            display: "flex",
                                                                            fontSize: "10px"
                                                                        }} key={`${key}`}>
                                                                            {
                                                                                <div style={{display: "flex"}}>
                                                                                    {!isDone ?
                                                                                        <div style={{
                                                                                            width: '10px',
                                                                                            height: '10px',
                                                                                            backgroundColor: value === 0 ? "red" : (value === 1 ? "yellow" : "green"),
                                                                                            borderRadius: '50%',
                                                                                            marginRight: '2px'
                                                                                        }}></div> : ""}
                                                                                    {
                                                                                        !isDone ?
                                                                                            users_id.find(u => u?._id === key)?.name
                                                                                            : "Судья " + (index + 1)
                                                                                    }
                                                                                </div>

                                                                            } : {value === 0 ?
                                                                            "Не готов"
                                                                            : (value === 1 ?
                                                                                "Судит" : (value === 2 ?
                                                                                    getScore(set?.[role ? role : "leader"]?.id, dance_set, users)?.[key]?.jj === 100 ?
                                                                                        "yes" :
                                                                                        (getScore(set?.[role ? role : "leader"]?.id, dance_set, users)?.[key]?.jj === 51 ? "maybe" : "_")

                                                                                    : "Что то не так"))}</div>)
                                                                })}

                                                                    {<div
                                                                        style={{fontSize: "10px"}}>Сумма: {getBallsJJ(set?.[role ? role : "leader"]?.id, dance_set, users)} </div>}
                                                                    {!isDone ?
                                                                        <AlertDialog
                                                                            variant={'text'}
                                                                            size={"small"}
                                                                            sx={{mb: -2}}
                                                                            name='Отменить'
                                                                            main_message='Отменить судейство?'
                                                                            message='Это отменит судейство'
                                                                            ok='Отменить'
                                                                            cancel='Подумаю еще'
                                                                            okFn={() => {
                                                                                cancelDance(
                                                                                    set?.number,
                                                                                    filters['event']?.event?.value ?? null,
                                                                                    filters['dance'] ?? null,
                                                                                    filters['category'] ?? null,
                                                                                    filters['class'] ?? null,
                                                                                    filters['round'] ?? null,
                                                                                    set?.number ?? null,
                                                                                    set?.[role ? role : "leader"] ?? null,
                                                                                    set?.follower ?? null,
                                                                                    roles ? roles : "leaders"
                                                                                )
                                                                            }}
                                                                        /> : ''
                                                                    }
                                                                </TableCell>
                                                        )
                                                        :
                                                        ""
                                                )
                                                :
                                                ''
                                            }
                                            { isDone && (filters?.round !== '1') ?
                                                <TableCell>
                                                    {getRoundAccess(set?.[role ? role : "leader"]?.id, dance_set, getNextRound(filters['round']) ) ?
                                                        (
                                                            <AlertDialog
                                                                variant={'text'}
                                                                name={"в " + (getNextRound(filters['round']) === "1" ? "финале" : getNextRound(filters['round']))}
                                                                main_message={"Отмена перевода в " + (getNextRound(filters['round']) === "1" ? "финал" : getNextRound(filters['round']))}
                                                                message={"Перевод в  " + (getNextRound(filters['round']) === "1" ? "финал" : getNextRound(filters['round'])) + ' будет отменен'}
                                                                ok='Отменить?'
                                                                cancel='Подумаю еще'
                                                                okFn={
                                                                    () => toNextRoundCancel(
                                                                        index,
                                                                        filters['event']?.event?.value ?? null,
                                                                        filters['dance'] ?? null,
                                                                        filters['category'] ?? null,
                                                                        filters['class'] ?? null,
                                                                        filters['round'] ?? null,
                                                                        set?.number ?? null,
                                                                        set?.[role ? role : "leader"] ?? null,
                                                                        set?.follower ?? null,
                                                                    )}
                                                                enabled={final_complete}
                                                            />
                                                        ) : (isEnd ? '' :
                                                            <Button disabled={final_complete} size="small"
                                                                    onClick={
                                                                        () => toNextRound(
                                                                            index,
                                                                            filters['event']?.event?.value ?? null,
                                                                            filters['dance'] ?? null,
                                                                            filters['category'] ?? null,
                                                                            filters['class'] ?? null,
                                                                            filters['round'] ?? null,
                                                                            set?.number ?? null,
                                                                            set?.[role ? role : "leader"] ?? null,
                                                                            set?.follower ?? null,
                                                                        )}>Провести</Button>)}
                                                </TableCell> : ''}
                                        </TableRow>)
                                }
                            )}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    const JJTable = ({typeName,typeValue,typeValueMany}) => {
        return(
            <TableContainer component={Paper}>
                <Table style={{minWidth: "600px"}}>
                    <TableHead>
                        <TableRow>
                            <TableCell padding="checkbox" sx={{
                                pl: 2,
                                width: "80px"
                            }}>{isDone ? "Место" : "Заход"}</TableCell>
                            <TableCell padding="normal">№</TableCell>
                            <TableCell padding="normal">{typeName}</TableCell>
                            {(!generated && start) ?
                                <TableCell
                                    padding="normal">{isDone ? "Баллы" : "Судейство"}</TableCell> : ''}
                            {isDone && (filters?.round !== '1') ?
                                <TableCell padding="normal"></TableCell> : ''}

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(sortedDataObj?.[typeValueMany] ?? []).map((set, index) => {
                                if ((Math?.trunc((index) / pair_count) + 1) === selectListRound || selectListRound === 0)
                                    return (
                                        set?.[typeValue]?.id ?
                                            <TableRow key={`${index}`} style={{
                                                backgroundColor: (Object.values(set?.jading_status ?? {j: 3}).every(value => value === 2) && !isDone) ? "#008f0029" :
                                                    ((set?.jading_status && !isDone) ? "#ffa50029" : null)
                                            }}
                                                      hover={false}>
                                                <TableCell>{isDone ? index +1 : Math?.trunc((index) / pair_count) + 1}</TableCell>
                                                <TableCell padding="normal"
                                                >{set?.number ?? null}</TableCell>
                                                <TableCell
                                                    padding="normal">{set?.[typeValue]?.name ?? "_"}</TableCell>
                                                {!generated && start ?
                                                    (set?.jading_status ?
                                                            <TableCell
                                                                padding="normal"
                                                                style={{}}>{Object.entries(set?.jading_status).map(([key, value], index) => {
                                                                return (
                                                                    <div style={{
                                                                        display: "flex",
                                                                        fontSize: "10px"
                                                                    }} key={`${key}`}>
                                                                        {
                                                                            <div style={{display: "flex"}}>
                                                                                {!isDone ?
                                                                                    <div style={{
                                                                                        width: '10px',
                                                                                        height: '10px',
                                                                                        backgroundColor: value === 0 ? "red" : (value === 1 ? "yellow" : "green"),
                                                                                        borderRadius: '50%',
                                                                                        marginRight: '2px'
                                                                                    }}></div> : ""}
                                                                                {
                                                                                    ! isDone ?
                                                                                        users.find(u => u?._id === key)?.name
                                                                                        : "Судья " + (index+1)
                                                                                }
                                                                            </div>

                                                                        } : {value === 0 ?
                                                                        "Не готов"
                                                                        : (value === 1 ?
                                                                            "Судит" : (value === 2 ?
                                                                                getScore(set?.[typeValue]?.id, dance_set, users)?.[key]?.jj === 100 ?
                                                                                    "yes" :
                                                                                    (getScore(set?.[typeValue]?.id, dance_set, users)?.[key]?.jj === 51 ? "maybe" : "_")

                                                                                : "Что то не так"))}</div>)
                                                            })}

                                                                {<div style={{fontSize: "10px"}}>Сумма: {getBallsJJ(set?.[typeValue]?.id, dance_set, users) } </div>}
                                                                {!isDone?
                                                                    <AlertDialog
                                                                        variant={'text'}
                                                                        size={"small"}
                                                                        sx={{mb: -2}}
                                                                        name='Отменить'
                                                                        main_message='Отменить судейство?'
                                                                        message='Это отменит судейство'
                                                                        ok='Отменить'
                                                                        cancel='Подумаю еще'
                                                                        okFn={() => {
                                                                            cancelDance(
                                                                                set?.number,
                                                                                filters['event']?.event?.value ?? null,
                                                                                filters['dance'] ?? null,
                                                                                filters['category'] ?? null,
                                                                                filters['class'] ?? null,
                                                                                filters['round'] ?? null,
                                                                                set?.number ?? null,
                                                                                set?.[typeValue] ?? null,
                                                                                set?.follower ?? null,
                                                                                typeValueMany
                                                                            )
                                                                        }}
                                                                    />:''
                                                                }
                                                            </TableCell>
                                                            : ""
                                                    )
                                                    :
                                                    ''
                                                }
                                                { isDone && (filters?.round !== '1') ?
                                                    <TableCell>
                                                        {getRoundAccess(set?.[typeValue]?.id, dance_set, getNextRound(filters['round']) ) ? "в "+
                                                            (getNextRound(filters['round']) === "1" ? "финале" : getNextRound(filters['round'])
                                                            ) : (isEnd ? '' :
                                                            <Button disabled={final_complete} size="small"
                                                                    onClick={
                                                                        () => toNextRound(
                                                                            index,
                                                                            filters['event']?.event?.value ?? null,
                                                                            filters['dance'] ?? null,
                                                                            filters['category'] ?? null,
                                                                            filters['class'] ?? null,
                                                                            filters['round'] ?? null,
                                                                            set?.number ?? null,
                                                                            set?.[typeValue] ?? null,
                                                                            set?.follower ?? null
                                                                        )}>Провести</Button>)}
                                                    </TableCell> : ''}
                                            </TableRow> : "")
                            }
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
    const renderJJTable = () => {
        return (
            <Stack>
                <Stack direction={"column"} alignItems="center">
                </Stack>
                <div ref={targetRef} style={{width: isPrint ? "1200px" : "auto"}}>
                    <Typography align="center" variant="subtitle1">
                        {
                            filters?.event?.event?.name
                            + ' ' + (filters?.dance ?? "")
                            + ' ' + (filters?.category ?? "")
                            + ' ' + (filters?.class ?? "")
                            + ' ' + ((filters?.round === "1"? "Финал" : filters?.round ) ?? "")
                            + ((selectListRound !== 0) ? " Заход " + selectListRound : '')
                            + ' ' + (isDone ? ' Результаты ' :'')
                            + ' ' + (filters?.role ?? "")
                        }
                    </Typography>
                    <div
                    >
                        {filters.round === "1" ?
                            (filters.role === "Leaders" || !filters.role ?
                                renderSkatingTableOnly("leader","leaders") :
                                renderSkatingTableOnly("follower","followers")) :
                            (filters.role === "Leaders" || !filters.role ?
                                <JJTable typeName="Leader" typeValue="leader" typeValueMany="leaders"/> :
                                <JJTable typeName="Followers" typeValue="follower" typeValueMany="followers"/>)
                        }

                    </div>
                </div>
            </Stack>

        )
    }
    const RenderTable = () => {
        //console.log(filters?.category)
        if(filters?.round){
            switch (filters?.category) {
                case "Strictly":
                    return (renderStrictlyTable())
                case "J&J":
                    return (renderJJTable())
            }
        }

    }

    const [openCollapse, setOpenCollapse] = useState(true)
    const handleExpandClick = () => {
        setOpenCollapse(!openCollapse);
    }
    const ExpandMore = styled((props) => {
        const {expand, ...other} = props;
        return <IconButton {...other} />;
    })(({theme}) => ({
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        variants: [
            {
                props: ({expand}) => !expand,
                style: {
                    transform: 'rotate(0deg)',
                },
            },
            {
                props: ({expand}) => !!expand,
                style: {
                    transform: 'rotate(180deg)',
                },
            },
        ],
    }));
    const renderFiler = () => {
        return (
            <>
                <Collapse in={openCollapse} timeout="auto" unmountOnExit>
                    {
                        events.length > 0 ?
                            <div style={{display: "flex", gap: "10px", marginBottom: "10px", flexWrap: "wrap"}}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Событие</InputLabel>
                                    <Select
                                        key="event-select"
                                        value={filters["event"]?.event?.value || ""} // Используем только строковое значение
                                        onChange={(event) => {
                                            const selectedEvent = events.find(e => e.event?.value === event.target.value);
                                            //console.log(selectedEvent,event,events)
                                            const tmp = {
                                                event: selectedEvent || null, // Сохраняем весь объект события
                                                dance: null,
                                                category: null,
                                                class: null
                                            }
                                            setFilters(tmp);
                                            filters_ref.current = tmp
                                            //getSetR()
                                        }}// Обнуляем другие фильтры
                                        label="Событие"
                                    >
                                        {events.map((e, index) => (
                                            <MenuItem key={index} value={e?.event?.value}>
                                                {e?.event?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Танец</InputLabel>
                                    <Select
                                        key="dance-select"
                                        value={filters["dance"] || ""}
                                        onChange={(event) => {
                                            setFilters({
                                                ...filters,
                                                dance: event.target.value,
                                                category: "",
                                                class: "",
                                                round: ""
                                            })
                                            filters_ref.current = {
                                                ...filters,
                                                dance: event.target.value,
                                                category: "",
                                                class: "",
                                                round: ""
                                            }
                                            //getSetR()
                                        }}// Сохраняем танец
                                        label="Танец"
                                    >
                                        {events.filter(ev => ev.event.value === filters["event"]?.event?.value)[0]?.dancesList?.map((dance, index) => (
                                            <MenuItem key={index} value={dance}>
                                                {dance}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Категория</InputLabel>
                                    <Select
                                        key="category-select"
                                        value={filters["category"] || ""}
                                        onChange={(event) => {
                                            setFilters({...filters, category: event.target.value,
                                                class: "",
                                                round: ""
                                            })
                                            filters_ref.current = {
                                                ...filters,
                                                category: event.target.value,
                                                class: "",
                                                round: ""
                                            }
                                            getSetR()
                                        }} // Сохраняем категорию
                                        label="Категория"
                                    >
                                        {events.filter(ev => ev.event.value === filters["event"]?.event?.value)[0]?.categoriesList?.[filters["dance"]]?.map((category, index) => (
                                            <MenuItem key={index} value={category?.name}>
                                                {category?.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth size="small">
                                    <InputLabel>Класс</InputLabel>
                                    <Select
                                        key="class-select"
                                        value={filters["class"] || ""}
                                        onChange={(event) => {
                                            setFilters({...filters, class: event.target.value, round: ''})
                                            filters_ref.current = {...filters, class: event.target.value, round: ''}
                                            getSetR()
                                        }} // Сохраняем класс
                                        label="Класс"
                                    >
                                        {events.filter(ev => ev.event.value === filters["event"]?.event?.value)[0]?.["classList"]?.[filters["dance"]]?.[filters["category"]]?.map((classItem, index) => (
                                            <MenuItem key={index} value={classItem}>
                                                {classItem}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {rounds().length > 0 ?
                                    <FormControl fullWidth size="small">
                                        <InputLabel>{"Этап"}</InputLabel>
                                        <Select
                                            key="round-select"
                                            value={filters["round"] || ""}
                                            defaultValue={''}
                                            onChange={(event) => {
                                                setFilters({...filters, round: event.target.value})
                                                filters_ref.current = {...filters, round: event.target.value}
                                                getSetR()
                                            }} // Сохраняем round
                                            label="Программа"
                                        >
                                            {(rounds()).map((roundItem, index) => (
                                                <MenuItem key={index} value={roundItem}>
                                                    {roundItem}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    : ''
                                }
                                {( filters?.category === "J&J" && (filters["round"]))?
                                <FormControl fullWidth size="small">
                                    <InputLabel>{"Роль"}</InputLabel>
                                    <Select
                                        key="role-select"
                                        value={filters["role"] || ""}
                                        defaultValue={"Followers"}
                                        onChange={(event) => {
                                            setFilters({...filters, role: event.target.value})
                                            filters_ref.current = {...filters, role: event.target.value}
                                        }} // Сохраняем round
                                        label="Программа"
                                    >
                                        {(["Leaders","Followers"]).map((roundItem, index) => (
                                            <MenuItem key={index} value={roundItem}>
                                                {roundItem}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>:""}

                            </div> : ''}
                </Collapse>
            </>
        )
    }
    return (
        <Box margin={"10px"}
            // onScroll={() => {
            //     setOpenCollapse(false)
            // }}
             sx={{
                 margin: "auto",
                 mt: 0,
                 ml: 1,
                 mr: 1,
                 p: 0,
                 overflow: 'auto',
                 height: (window.innerHeight - 75) + 'px'
             }}>
            <BlurredComponent_all isBlurred={(!isConnected || loading)} message={isConnected ? progress + "%" : "Все будет хорошо, но сейчас нет связи с сервером!"} />
            <div
                style={{
                    position: 'fixed',
                    zIndex: '10',
                    marginLeft: "50px",
                    marginTop: "-50px",
                    minWidth: 1024
                }}
            >
                <ExpandMore
                    expand={openCollapse}
                    onClick={handleExpandClick}
                    aria-expanded={openCollapse}
                    aria-label="show more"
                ><ExpandMoreIcon/>
                </ExpandMore>
            </div>
                {renderFiler()}
                <RenderTable/>
        </Box>
);
};

export default Results;
